export default __webpack_public_path__ + "static/media/renown-showcase.f923d536.webp";